import { IUserDisplayOptions } from '../interfaces/user-display-options.interface';

export const START_AT_PAGE_DEFAULT_VALUE = '1';

export const DEFAULT_SWISS_USER_DISPLAY_OPTIONS: IUserDisplayOptions = {
    showCompanyInfos: true,
    showAccounts: false,
    hidePreviousYear: false,
    showAccountProofForBalance: false,
    showAccountProofForIncome: false,
    showCoverSheet: true,
    showCompanyLogo: false,
    showUIDonCover: true,
    showTableOfContents: true,
    showNotesInDetailInToc: false,
    disableBalanceSheetPageBreak: false,
    showDecimalPlaces: true,
    showEmptyLines: false,
    showFliTotal: false,
    showGroupHeaders: false,
    showGroupTotals: true,
    showFcp: true,
    showAop: true,
    showCfs: true,
    showNotes: true,
    showComplementaryReports: true,
    showEms: false,
    showFas: true,
    printInGrayscale: false,
    showCustomPageNumbers: false,
    startAtPage: START_AT_PAGE_DEFAULT_VALUE,
    mainTitle: null,
    subtitle: null,
    dateTitle: null,
    // REV-20899: reclasses are now always included in totals.
    showReClassInSums: true,
    showAdjustmentInSums: false,
    showRatios: true,
    showShareholderInformation: false,
    incomeItemNameForCalculatingRatio: null,
    showAccountNumbers: false,
    aopHideDecimalPlacesValues: false,
    aopHideDecimalPlacesRatios: false,
    aopHideEmptyLines: false,
    notesHideDecimalPlacesValues: false,
    notesHideDecimalPlacesRatios: false,
    notesHideEmptyLines: false,
    fxShowStatementDisplayColumns: true,
    finStatementHideDecimalPlacesValues: false,
    finStatementHideDecimalPlacesRatios: false,
    finStatementHideEmptyLines: false,
    finStatementRoundToThousands: false,
    notesRoundToThousands: false,
    aopRoundToThousands: false,
    nonBreakingHyphen: false,
    applyGroupingMasking: true,
    showReportCompanyLogo: false,
    repeatAppendixTitle: true,
};
